export default __webpack_public_path__ + "a4258d96f50bc165adea1368a10ea59c.svg";